import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const freeBetsList = createAsyncThunk(
  "freeBetsList/freeBetsList",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post("freebets/get-all", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const freeBetsListSlice = createSlice({
  name: "freeBetsList",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(freeBetsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(freeBetsList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(freeBetsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default freeBetsListSlice.reducer;
